export const answers = {
  1: 'Rarely',
  2: 'Occasionally',
  3: 'Often',
  4: 'Usually',
  5: 'Most of the time',
};

export default answers;
